import { styled } from 'styled-components';

export const GraphWorkspace = styled.div`
  border: 1px solid #d5deea;
  border-radius: 8px;
  background: #fff;
  margin: 16px 0;
  overflow: hidden;

  .graph-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px 16px;
    border-bottom: 1px solid #d5deea;
  }
  .graph-toolbar-title {
    flex: 1;
    min-width: 180px;
  }
  .graph-toolbar-title h2 {
    margin: 0 0 4px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
  }
  .graph-toolbar-title small {
    color: #526579;
  }
  .graph-notice {
    padding: 8px 16px;
    background: #eef5fc;
    font-size: 13px;
  }
  .graph-columns {
    display: grid;
    grid-template-columns: 220px minmax(320px, 1fr) 360px;
    min-width: 0;
  }
  && .graph-library,
  && section[aria-label='Selected properties'] {
    margin: 0;
    padding: 16px;
    border: 0;
    border-radius: 0;
    overflow: auto;
    max-height: clamp(420px, calc(100vh - 420px), 680px);
  }
  && .graph-library h3 {
    margin: 0 0 12px;
    font-size: 14px;
    font-weight: 600;
  }
  .graph-library label {
    display: block;
    margin-bottom: 8px;
    font-size: 13px;
  }
  && .graph-library input {
    box-sizing: border-box;
    width: 100%;
  }
  .graph-job-list {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 260px;
    overflow: auto;
  }
  && .graph-job {
    display: flex;
    gap: 8px;
    align-items: center;
    width: calc(100% - 2px);
    text-align: left;
    padding: 10px;
    margin: 0 0 8px;
    background: #f8fafc;
    border: 1px solid #dce5ed;
    cursor: grab;
    height: auto;
    min-height: 50px;
  }
  && .graph-job:active {
    cursor: grabbing;
  }
  && .graph-job:disabled {
    cursor: not-allowed;
  }
  .graph-job span {
    min-width: 0;
  }
  .graph-job strong {
    display: block;
    font-size: 13px;
    white-space: normal;
    line-height: 1.4;
  }
  .graph-job small {
    display: block;
    color: #526579;
    font-size: 11px;
  }
  .graph-job-grip {
    color: #8293a5;
    font-size: 20px;
  }
  .graph-outline {
    margin-top: 18px;
    border-top: 1px solid #e6edf3;
    padding-top: 12px;
  }
  .graph-outline ol {
    padding: 0;
    margin: 0 0 14px;
    list-style: none;
  }
  .graph-outline li {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  && .outline-select {
    flex: 1;
    min-width: 0;
    text-align: left;
    margin: 2px 0;
    font-size: 12px;
    height: auto;
    min-height: 32px;
    padding: 6px 10px;
    white-space: normal;
    justify-content: flex-start;
  }
  && .outline-select[aria-pressed='true'] {
    background: #e8f2fc;
    border-color: #2a6ea6;
  }
  && .outline-remove {
    margin: 0;
    padding: 4px 7px;
  }
  .graph-canvas {
    height: clamp(420px, calc(100vh - 420px), 680px);
    min-width: 0;
    border-left: 1px solid #d5deea;
    border-right: 1px solid #d5deea;
    background: #f8fafc;
  }
  .graph-empty {
    max-width: 280px;
    padding: 16px;
    color: #526579;
    text-align: center;
    pointer-events: none;
  }
  .template-flow-node {
    box-sizing: border-box;
    width: 220px;
    height: 84px;
    padding: 12px 14px;
    border: 1px solid #aebfd0;
    border-left: 4px solid #2a6ea6;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 2px 6px #12345612;
  }
  .template-flow-node[data-selected='true'] {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px #1677ff35;
  }
  .template-flow-node[data-source='true'] {
    border-style: dashed;
    background: #edf5ff;
  }
  .template-flow-node[data-deleted='true'] {
    opacity: 0.65;
  }
  .flow-node-title {
    font-size: 13px;
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .flow-node-meta {
    display: flex;
    gap: 6px;
    margin-top: 10px;
    font-size: 11px;
    color: #526579;
  }
  .flow-node-meta span {
    padding: 2px 6px;
    border-radius: 4px;
    background: #edf2f7;
  }
  && .react-flow__handle {
    width: 12px;
    height: 12px;
    background: #2a6ea6;
    border: 2px solid white;
  }
  && .react-flow__controls button {
    margin: 0;
    width: 28px;
    height: 28px;
    padding: 5px;
    border: 0;
    border-bottom: 1px solid #e6edf3;
    border-radius: 0;
    background: white;
  }
  && .react-flow__controls button:disabled {
    opacity: 0.5;
  }
  && section[aria-label='Selected properties'] h2 {
    margin-top: 0;
  }
  && section[aria-label='Selected properties'] legend {
    float: none;
    width: auto;
    padding: 0 5px;
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
  }
  .connection-summary {
    margin-bottom: 4px;
    font-size: 13px;
  }
  .edge-conditions .condition-summary {
    margin-bottom: 12px;
    font-size: 12px;
    overflow-wrap: anywhere;
  }
  .condition-alternative {
    margin-top: 10px;
  }
  .condition-alternative .ant-card-head {
    min-height: 36px;
    padding: 0 10px;
  }
  .condition-alternative .ant-card-head-title {
    font-size: 12px;
    white-space: normal;
  }
  .condition-alternative .ant-tag {
    margin-inline-end: 0;
    font-size: 10px;
  }
  .condition-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 24px;
    gap: 4px;
    padding: 8px 0;
  }
  .condition-row + .condition-row {
    border-top: 1px dashed #e6edf3;
  }
  .condition-row[data-readonly='true'] {
    grid-template-columns: minmax(0, 1fr);
  }
  .condition-fields {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 6px;
  }
  .condition-field {
    grid-column: 1 / -1;
  }
  .condition-fields > .ant-select,
  .condition-fields > .ant-input {
    width: 100%;
    min-width: 0;
  }
  .condition-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
  .condition-no-value {
    align-self: center;
    font-size: 12px;
  }
  .condition-or.ant-divider {
    margin: 12px 0 2px;
  }
  .condition-add-alternative {
    margin-top: 12px;
  }
  @media (max-width: 1250px) {
    .graph-columns {
      grid-template-columns: 190px minmax(280px, 1fr) 320px;
    }
  }
  @media (max-width: 1050px) {
    .graph-columns {
      grid-template-columns: 210px minmax(0, 1fr);
    }
    && section[aria-label='Selected properties'] {
      grid-column: 1 / -1;
      max-height: none;
      border-top: 1px solid #d5deea;
    }
    .graph-canvas {
      height: 560px;
      border-right: 0;
    }
  }
  @media (max-width: 700px) {
    .graph-columns {
      grid-template-columns: minmax(0, 1fr);
    }
    && .graph-library {
      max-height: 300px;
    }
    .graph-canvas {
      height: 480px;
      border-left: 0;
      border-top: 1px solid #d5deea;
    }
  }
`;
